module.exports = __webpack_public_path__ + "assets/images/card-pg-6_ebb10e8fd46ae9529b9d9b0d51a54028.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/card-pg-6.png
// module id = 193
// module chunks = 0